import VuexTypes from '@/store/types/index';

const DevicesTypes = VuexTypes.devices;
export default {
  [DevicesTypes.DEVICES_LIST]: (state, { data, status }) => {
    state.devicesList = { data, status };
  },
  [DevicesTypes.DEVICES_CREATE_DATA]: (state, { data, status }) => {
    state.deviceCreateData = { data, status };
  },
  [DevicesTypes.DEVICES_UPDATE_DATA]: (state, { data, status }) => {
    state.deviceUpdateData = { data, status };
  },
  [DevicesTypes.DEVICES_CREATE]: (state, { data, status }) => {
    state.deviceCreate = { data, status };
  },
  [DevicesTypes.DEVICES_UPDATE]: (state, { data, status }) => {
    state.deviceUpdate = { data, status };
  },
  [DevicesTypes.DEVICES_UPDATE_ACTIVE]: (state, { data, status }) => {
    state.deviceUpdateActive = { data, status };
  },
};
